import { SQW_KEY, VERSION, yourWishesUrls } from "../../constants/ApiUrls";
import {
  getData,
  postData,
  deleteData,
  updateData,
} from "../../networkManager/NetworkManager";
export const getStatusQuo = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.GET_STATUS_QUO}`
  );
};
export const postStatusQuo = async (statusQuoIds, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.USER_STATUS_QUO}`,
    statusQuoIds
  );
};
export const getUserStatusQuo = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.USER_STATUS_QUO_WITH_MEDIA}`
  );
};
export const uploadDocument = async (payload, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.USER_STATUS_QUO_MEDIA}`,
    payload
  );
};
export const putDocument = async (payload, id) => {
  return await updateData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.USER_STATUS_QUO_MEDIA}`,
    payload
  );
};
export const getUploadedDoc = async (id, meta) => {
  const params = {
    pageSize: meta?.pageSize ? meta.pageSize : 0,
    pageNumber: meta?.pageNumber ? meta.pageNumber : 0,
    sortOrder: meta?.sortOrder ? meta.sortOrder : "asc",
  };
  return await getData(
    SQW_KEY +
      VERSION +
      `${id}/${yourWishesUrls.USER_STATUS_QUO_MEDIA}?&PageSize=${params.pageSize}&PageNumber=${params.pageNumber}&SortOrder=${params.sortOrder}`
  );
};
export const deleteDocument = async (payload, id) => {
  return await deleteData(
    SQW_KEY + VERSION + `${id}/${yourWishesUrls.USER_STATUS_QUO_MEDIA}`,
    "?statusQuoMediaFileId=" + payload
  );
};
export const getUserWish = async () => {
  return await getData(SQW_KEY + VERSION + yourWishesUrls.USER_WISH);
};
export const postUserWish = async (statusQuoIds) => {
  return await postData(SQW_KEY + VERSION + yourWishesUrls.USER_WISH, {
    statusQuoIds,
  });
};
